export { default } from './GeonameMap';
